import MembershipOrderItem from 'components/mweb/HalalboxPrime/MembershipOrderItem';
import React from 'react';
import { Link } from 'react-router-dom';

import { isObjectEmpty } from 'hb-redux-store/util/miscellaneousServices';

import Button from '../../components/common/Button/Button';
import Icon from '../../components/mweb/Icon/Icon';

const Orders = props => {
  const { title, orders, pastOrders, onReorder } = props;
  return (
    <div className="orders">
      {title && <div className="orders--title">{title}</div>}
      {orders.map(order => {
        const {
          firstOrderItem,
          orderPaymentType: paymentMode,
          orderPayableAmount: payableAmount,
          paid,
          paymentLink,
          isOrderCancelled,
          isOrderReturned,
          isOrderRefunded,
          orderCancelledText,
          orderReturnedText,
          orderRefundedText,
          isOrderReplaced,
          orderReplacedText,
          isSubscription,
          membershipDetails = {},
        } = order;
        const cancelled = isOrderCancelled && orderCancelledText;
        const returned = isOrderReturned && orderReturnedText;
        const refunded = isOrderRefunded && orderRefundedText;
        const replaced = isOrderReplaced && orderReplacedText;
        const showMembershipDetails = isObjectEmpty(membershipDetails);
        return (
          <div className="order-card" key={order?.orderNo}>
            <div className="justify-content--space-between">
              <div>
                <div className="order-card--order-no">
                  <Link to={`/my/order/${order.orderNo}`}>
                    {order?.shipmentTitle}
                  </Link>
                </div>
                <div className="order-card--order-date">{order?.orderDate}</div>
              </div>
              {pastOrders && (
                <Button
                  className="button button-ghost"
                  onClick={() => onReorder(order?.orderNo)}
                >
                  Reorder
                </Button>
              )}
              {!pastOrders && (
                <Link
                  to={`/my/order/${order.orderNo}`}
                  className="button button-ghost"
                >
                  Track
                </Link>
              )}
            </div>
            {firstOrderItem && (
              <ul className="">
                <li className="order-items justify-content--space-between">
                  <div className="li-marker flex-shrink-0" />
                  <div className="order-card--items flex-grow-1">
                    <div className="justify-content--space-between">
                      <div>
                        <div>{firstOrderItem?.productName}</div>
                        <div>{firstOrderItem?.quantityType}</div>
                        {firstOrderItem?.quantity && (
                          <div>{`Qty: ${firstOrderItem?.quantity}`}</div>
                        )}
                      </div>
                      {paymentMode === 'POD' && paymentLink && !paid && (
                        <a
                          href={paymentLink}
                          className="button button-primary order-card--pod-cta"
                        >
                          Pay Now
                        </a>
                      )}
                    </div>

                    <div className="justify-content--space-between">
                      {firstOrderItem?.onsale && firstOrderItem?.salePrice > 0 && (
                        <div>
                          {firstOrderItem?.retailPrice && (
                            <span className="order-card--items--striked-price">
                              &#8377;{firstOrderItem?.retailPrice}
                            </span>
                          )}
                          {firstOrderItem?.salePrice && (
                            <span className="order-card--items--final-price">
                              &#8377;{firstOrderItem?.salePrice}
                            </span>
                          )}
                        </div>
                      )}
                      {!firstOrderItem?.onsale && (
                        <div>
                          <span className="order-card--items--final-price">
                            &#8377;{firstOrderItem?.retailPrice}
                          </span>
                        </div>
                      )}
                      {order?.otherItemCount > 0 && (
                        <div className="order-card--items--n-items">
                          {`+ ${order?.otherItemCount} more ${
                            order?.otherItemCount === 1 ? 'item' : 'items'
                          }`}
                        </div>
                      )}
                    </div>
                    {isSubscription && (
                      <div className="order-card--items--subscription">
                        <Icon class="icon-app-bar-subscription" size={28} />
                        <div className="subscription-tag">
                          Ramadan Subscription
                        </div>
                      </div>
                    )}
                    {cancelled && (
                      <div className="pill error-pill">
                        <Icon
                          class="icon-status-order-cancelled pill--icon"
                          size={15}
                        />
                        {cancelled}
                      </div>
                    )}
                    {returned && (
                      <div className="pill error-pill">
                        <Icon
                          class="icon-status-order-returned pill--icon"
                          size={15}
                        />
                        {returned}
                      </div>
                    )}
                    {refunded && (
                      <div className="pill delivered-pill">
                        <Icon
                          class="icon-status-order-refunded pill--icon"
                          size={15}
                        />
                        {refunded}
                      </div>
                    )}
                    {replaced && (
                      <div className="pill delivered-pill">{replaced}</div>
                    )}
                  </div>
                </li>
              </ul>
            )}
            {showMembershipDetails && (
              <ul>
                <li className="order-items">
                  <div className="order-details--membership-container">
                    <div className="li-marker order-details--membership-backgraound-color" />
                    <MembershipOrderItem
                      membershipDetails={membershipDetails}
                      containerStyle="orders--membership-sub-container"
                    />
                  </div>
                </li>
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Orders;
